import { ReactNode } from "react";

import { OpenTofuMigrationContext } from "./context";
import useOpenTofuMigration from "./useOpenTofuMigration";

type DashboardWidgetsOpenTofuMigrationProviderProps = {
  children: ReactNode;
};

const DashboardWidgetsOpenTofuMigrationProvider = ({
  children,
}: DashboardWidgetsOpenTofuMigrationProviderProps) => {
  const openTofuMigration = useOpenTofuMigration();

  return (
    <OpenTofuMigrationContext.Provider value={openTofuMigration}>
      {children}
    </OpenTofuMigrationContext.Provider>
  );
};

export default DashboardWidgetsOpenTofuMigrationProvider;
